import type { SolutionSector } from "../sectors";
import { ACCESS_QUESTION, ACCURACY_QUESTION, COST_QUESTION, EFFORT_QUESTION, HOSTING_QUESTION, LOGO } from "./shared";

export const HOTELS: SolutionSector = {
  slug: "hotels",
  name: "Hotels",
  demoOrg: "Demo (Hotels)",
  story: "hotels",
  metadata: {
    title: "AI for hotel group operations reviews | Your Twin",
    description:
      "See open supplier queries, missing paperwork and owners across your properties. Your Twin connects SunSystems, Google Sheets, SharePoint and Outlook.",
  },
  hero: {
    label: "Hotels",
    title: ["See every", "property’s", "open actions."],
    lead: [
      "Your Twin connects ",
      LOGO.sunsystems,
      " with trackers in ",
      LOGO.sheets,
      ", supplier documents in ",
      LOGO.sharepoint,
      " and updates in ",
      LOGO.outlook,
      ", so every property’s open actions and owners reach the group review.",
    ],
    cta: "Bring a group operations review",
    buyer: "For group operations directors, finance directors and regional general managers",
    instrumentLabel: "The group Twin · Property, action, supplier and owner",
  },
  replay: {
    title: "Which actions are\nstill open this week?",
    lead: "Ask across SunSystems, SharePoint and Outlook. See each open item beside its property, amount and owner.",
  },
  outcomes: {
    title: "Every property’s actions\nin one review.",
    lead: "Group operations sees the open items at each property, with the evidence and owner beside them.",
    items: [
      { title: "Bring property actions together.", body: "Review each property’s open actions in one place.", show: "sources" },
      { title: "Find the paperwork gap.", body: "See which actions lack the agreed supporting records.", show: "status" },
      { title: "Keep local ownership visible.", body: "Bring each recorded owner into the group review.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose the group operations review your team prepares today." },
  questions: [
    {
      q: "Does it connect to our PMS, or report RevPAR?",
      a: "Not yet. No hotel property management system is in the connector list today, so occupancy and RevPAR are outside this workflow. We check your systems with you before anything is in scope.",
    },
    ACCESS_QUESTION,
    HOSTING_QUESTION,
    ACCURACY_QUESTION,
    EFFORT_QUESTION,
    COST_QUESTION,
  ],
  closing: "Start with one\ngroup operations review.",
};
